import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HeroSection() {
  return <section data-section-id="252775" id="hero-overview" className="relative flex min-h-[80vh] w-full items-center justify-center bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/chipper_forestry_mulching_hero.png')] bg-cover bg-center bg-no-repeat md:min-h-screen bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0 bg-black/60 backdrop-blur-[2px]" />

      {}
      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <h1 className="font-default text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl md:text-6xl lg:text-[66px]">
          Professional Land Clearing & Forestry Mulching Services
        </h1>
        
        <h2 className="font-default mt-6 max-w-3xl text-lg font-medium text-white/90 sm:text-xl md:text-[20px]">
          From dense overgrowth to cleared land—we handle it all with precision and care
        </h2>

        {}
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto px-8 py-6 text-base font-semibold bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg shadow-lg transition-all">
            <Link to="/contact-us/">Schedule an Estimate</Link>
          </Button>
          
          <Button asChild variant="secondary" size="lg" className="w-full sm:w-auto px-8 py-6 text-base font-semibold bg-secondary hover:bg-secondary/90 text-secondary-foreground rounded-lg shadow-md transition-all">
            <Link to="tel:402-609-8440">Call Now: 743-336-7302</Link>
          </Button>
        </div>
      </div>
    </section>;
}